import { FacturaGuias } from "./facturaguias";
import { ConceptoFactura } from "./conceptofactura";
import { CancelacionFactura, EstatusCancelacion } from "./cancelacionfactura";
import { TimbradoFactura } from "./timbradofactura";
import { NotaDeCredito } from "./notadecredito";
import { GuiaDTO } from "./guia";
import { TipoPersona } from "./identificacion";
import { StatusGuia } from "./status";
import { Direccion, DireccionDTO } from "./direccion";
import { PagoFactura } from "./pagofactura";


export enum TipoCaptura {
    Manual,
    DesdeGuia
}

export enum TipoFactura {
    Contado = 0,
    Credito = 1
}
export enum OrigenFactura {
    /**La factura fue creada manualmente por el usuario */
    Manual = 0,
    /**Factura de guias de contado */
    GuiasContado = 1,
    /**Factura con guias de un contrarecibo de cobranza */
    Cobranza = 2,

    /**Factura de las guias de público general */
    PublicoGeneral = 3,

    /**Factura desde el modulo de facturación online */
    FacturacionOnline = 4,

    /**Factura creada de las guías de publico general de forma manual */
    PublicoGeneralManual = 5,

    /**Factura creada de las guías de publico general de forma automática */
    PublicoGeneralAutomatico = 6,

    /**Factura creada en una nota de crédito */
    NotaDeCredito = 7,

    /**Factura creada automaticamente cuando se paga una guía de contado */
    AutomaticaGuiaPagadaContado = 8,

    /**Factura creada para el pago de otra */
    REP = 9,

    /**Factura creada a partir de un conjunto de guías de prepago manualmente */
    GuiasPPManual = 10,

    /**Factura creada automáticamente al comprar el paquete de guías de PP */
    GuiaPPAutomatica = 11,

    NotaDeCargo = 12,

    GuiaPPCobranza = 13,
}


export interface Factura {
    IdRegistro: number;

    /**Fecha en la que se creó la factura */
    FechaCreacion: Date | string;

    /**Fecha que se va a utilizar para timbrar la factura */
    FechaFactura: Date | string;

    /**Fecha con la que se debe de registrar la póliza contable de esta factura */
    FechaPolizaContable: Date | string;

    /**Id de Cliente de la factura */
    IdCliente: number;

    /**Sucursal de cobranza de la factura, normalmente es la sucursal del cliente */
    IdSucursalCobranza: number | null;

    ReceptorFactura: ReceptorFactura;
    EmisorFactura: EmisorFactura;

    /**Numero de cuenta ordenante */
    NoCuentaOrdenante: string;

    /**Numero de cuenta beneficiaria */
    NoCuentaBeneficiaria: string;

    Tipo: TipoFactura;

    /**Sucursal de la factura, según las pláticas con el contador todas las facturas obligatoriamente deben de tener una sucursal asignada */
    IdSucursal: number;

    ClaveSatRegimenFiscalEmisor: string;

    /**Id del metodo de pago del SAT */
    IdMetodoPagoSAT: number;

    /**Id de la forma de pago del SAT */
    IdFormaPagoSAT: number;

    /**Método de pago de sat de la factura */
    ClaveMetodoPagoSAT: string;

    ClaveSatUsoReceptor: string;

    /**Id de Moneda con la que se opera la factura */
    ClaveSatMoneda: string;

    TipoCambio: number;

    /**Serie de la factura */
    Serie: string;

    /**Folio de la factura, consecutivo y unico */
    Folio: number;

    /**Si es que esta factura representa un conjunto de guias facturadas es el conjunto de guias */
    GuiasFacturadas: FacturaGuias;

    /**Los conceptos de la factura */
    Conceptos: ConceptoFactura[];

    /**Pagos de facturas relacionadas a esta factura, Debe ser null si el tipo de comprobante es diferente a Pago (P) */
    PagosFacturas: PagoFactura[];

    /**Si existe, indica que la factura fue cancelada */
    Cancelacion: CancelacionFactura;

    /**Datos del timbrado de la factura */
    Timbrado: TimbradoFactura;

    /**En caso de que la factura sea una nota de credito esta propiedad será diferente de null y contendrá datos referentes a la nota */
    InformacionDeNotaDeCredito: NotaDeCredito;

    /**Indica la forma en que la factura fue capturada */
    TipoCaptura: TipoCaptura;

    /**Observaciones de la factura */
    Observaciones: string;

    /**Origen de la factura */
    Origen: OrigenFactura;

    /**Si esta es una factura de corrección de otra factura, este es el id de la facturaorigal */
    IdFacturaCorreccionOrigen: number | null;

    /**Correo al que se enviará la factura */
    CorreoFacturacion: string;

    /**Id de la colonia del cliente */
    IdColonia: number | null;

    /**Dirección del cliente */
    Direccion: Direccion;


    /**
     * Indica que esta factura fue pagada sin REPs, ya sea de crédito o de contado
     * esto implica que a pesar de que no tenga REPs el saldo de la factura va a ser 0, y se
     * va a considerar un abono a la factura igual al total de la misma en el view y en los abonos a crédito de los clientes.
     * Este valor lo tienen las facturas de crédito/contado que fueron pagadas con el antigüo proceso de cobranza pero que no tienen REP.
     * Fue necesario introducir este campo para igualar los saldos de los créditos en la migración del proceso de cobranza anterior al nuevo proceso de cobranza con REPs
     */
    PagadaSinRep: boolean;

    /**
     * Indica que esta factura esta registrada como que este de PUE, pero que en realidad es de crédito. Pudiendo ser que este o no cobrada por cobrana
     * Estas facturas provienen del antiguo proceso de cobranza, y deben de ser contabilizadas como un cargo para el crédito del cliente, siempre y cuando no esten canceladas.
     * Todas estas facturas deberán de ser canceladas y refacturadas con el tipo PPD para que se le puedan agregar los REPs correspondientes
     */
    PuePeroCredito: boolean;

    /**Indica que esta factura esta registrada como PPD, pero que en realidad es de contado, por lo que no debe de afectar a los cargos de crédito */
    PpdPeroContado: boolean;

    /**Es el código postal que indica el lugar de expedición de la factura, este se obtiene de la sucursal al momento de registrarla */
    CodigoPostal: string;

    ClaveSatRegimenFiscalReceptor: string;

    EsFacturaLogistica: boolean;

    PuedeTenerCalculo6Decimales:boolean;
}


/**Datos del emisor de una factura */
export interface EmisorFactura {
    /**Atributo requerido para registrar la Clave del Registro Federal de Contribuyentes correspondiente al contribuyente emisor del comprobante. */
    Rfc: string;

    /**Atributo opcional para registrar el nombre, denominación o razón social del contribuyente emisor del comprobante. */
    Nombre: string;
}

/**Datos del receptor de una factura */
export interface ReceptorFactura {

    /**Atributo requerido para precisar la Clave del Registro Federal de Contribuyentes correspondiente al contribuyente receptor del comprobante. */
    Rfc: string;

    /**Atributo opcional para precisar el nombre, denominación o razón social del contribuyente receptor del comprobante. */
    Nombre: string;

    /**Atributo condicional para registrar la clave del país de residencia para efectos fiscales del receptor del comprobante, cuando se trate de un extranjero, y que es conforme con la especificación ISO 3166-1 alpha-3. Es requerido cuando se incluya el complemento de comercio exterior o se registre el atributo NumRegIdTrib. */
    ResidenciaFiscal: string;

    /**Atributo condicional para expresar el número de registro de identidad fiscal del receptor cuando sea residente en el extranjero. Es requerido cuando se incluya el complemento de comercio exterior. */
    NumeroRegistroIdentidadFiscal: string;

    /**Tipo de persona que es el receptor de esta factura */
    TipoPersona: TipoPersona;

    RegimenFiscal: string;
}

export interface DatosFacturaCliente {
    IdCliente: number | null;
    DiasCredito: number | null;
    IdSucursalCobranza: number | null;
    NoCuentaOrdenante: string;
    ReceptorFactura: ReceptorFactura;
    IdColonia: number | null;
    Direccion: Direccion;
}

/**DTO de la factura, aqui van los campos extras de la factura como los datos calculados */
export interface FacturaDto extends Factura {
    /**Nombre del cliente relacionado con la factura */
    NombreCliente: string;
    CorreoClienteFacturacion: string;

    Calculo6Decimales:boolean;

    /**Es true si la factura está cancelada */
    EsCancelada: boolean;

    /**Es true si la factura es PP y esta pagada, es false si es PPD y no esta pagada o null si no es PPD */
    EsPPDPagada: boolean | null;

    /**Serie y folio de la factura */
    SerieFolio: string;

    /**Importe total de la factura */
    ImporteTotal: number;

    /**Importe subtotal de la factura */
    ImporteSubtotal: number;

    /**Importe total de IVA de la factura */
    TotalIVA: number;

    /**Importe total de IEPS de la factura */
    TotalIEPS: number;

    TotalIVAGuias: number;
    MismosImpuestos: boolean;

    /**Importe total de retención de iva de la factura */
    TotalRetencionIVA: number;

    /**Es true si la factura está timbrada */
    EsTimbrada: boolean;

    /**Es true si la factura proviene de cobranza */
    EsDeCredito: boolean;

    /**Es true si la factura es una nota de crédito */
    EsNotaDeCredito: boolean;

    /**Es true si la factura es una nota de cargo */
    EsNotaDeCargo: boolean;

    /**Folio de la factura que corrigió esta factura */
    FolioFacturaCorrigio: string;

    /**Si está factura es una corrección de otra es el folio de la fatura que fue corregida, si no es null */
    FolioFacturaCorregida: string;

    /**En caso de ser una nota de crédito o de cargo, es el folio de la factura original */
    FolioFacturaOriginal: string;

    /**Son las guias que fueron facturadas, de las cuales provienen las facturas */
    GuiasQueFueronFacturadas: GuiaDTO[];

    /**True si esta póliza esta contabilizadas */
    Contabilizada: boolean;

    /**True si esta poliza fue cancelada y si la cancelación tiene una póliza relacionada */
    CancelacionContabilizada: boolean;

    /**True si la factura tiene retenciones */
    TieneRetencionesIVA: boolean;

    /**Nombre de la sucursal de la factura */
    NombreSucursal: string;

    /**Nombre de la sucursal de cobranza del cliente */
    NombreSucursalCobranza: string;

    /**Id de la sucursal de cobranza */
    IdSucursalCobranza: number | null;

    /**Iata de la sucursal de cobranza del cliente */
    IataSucursalCobranza: string;

    /**Iata de la sucursal a la que hace referencia la factura */
    IataSucursal: string;

    /**Método de pago de sat de la factura */
    ClaveMetodoPagoSAT: string;

    /**Cuando esta factura es de método de pago ppd representa el total de lo que se ha abonado a la misma */
    TotalAbonado: number;

    /**Cuando esta factura es de método de pago ppd representa el resto por pagar */
    Saldo: number;

    /**
     * Fecha en la que se pago la factura 
     * Si esta no esta liquidada no debe de aparecer en pantalla
     */
    FechaPago: Date | string | null;
    FechaCancelacion: Date | string | null;
    /**Los folios de las notas de crédito que estan siendo aplicados a esta factura, separados por coma */
    FoliosNotaCredito: string;

    /**Estatus de la cancelación de la factura */
    EstatusDeCancelacion: EstatusCancelacion | null;

    /**El numero de parcialidad del ultimo abono de REP aplicado a esta factura */
    UltNumParcialidadPago: number | null;

    /**REPs que han sido aplicados a esta factura */
    FolioReps: string;

    /** Si la factura es de crédito es true si ya esta pagada o false si no esta pagada, Si la factura es de contado es null*/
    PagadaCredito: boolean | null;
}

/**Modal para la cancelación de facturasd */
export interface CancelarFacturaModel {
    /**Id de la factura que se va a cancelar */
    IdFactura: number;
    /**Motivo de cancelación de la factura */
    MotivoCancelacion: string;

    /**Por cada guia de la factura, el motivo de cancelación por guia. Puede ser que no todas las guias tengan motivo de cancelación */
    Guias: MotivoCancelacionGuiaModel[];

    /**
   * En caso de que la factura haya sido cancelada manualmente por el usuario desde el portal del SAT, deberá de subir el acuse de cancelación provisto por el SAT.
   * Si esto es null, el sistema intentará cancelar el timbrado internamente
   */
    AcuseCancelacionSAT: string | null;
}

/**Un motivo de cancelación por guia */
export interface MotivoCancelacionGuiaModel {
    IdGuia: number;
    MotivoCancelacion?: string | null;
}

export interface FacturacionOnlineParametros {
    FolioGuia: string;
    ClaveCliente?: number;
}


export interface FacturaOnlineDTO {
    Folio: string;

    NombreSucursalOrigen: string;
    NombreClienteOrigen: string;
    NombreDireccionOrigen: string;

    NombreSucursalDestino: string;
    NombreClienteDestino: string;
    NombreDireccionDestino: string;

    NombreSucursalActual: string;

    StatusActual: StatusGuia;
    CantidadPaquetes: number;
    CantidadSobres: number;
    EsDeAcuse: boolean;
    FolioGuiaAcuse: string;
    idFactura: number | null;
    EsFacturada: boolean;
    EsTimbrada: boolean;
    EsDePublicoGeneral: boolean;

    //Datos para la edición de facturación online
    Receptor: ReceptorFactura;
    CorreoFacturacion: string;
    DireccionFacturacionOnline: Direccion;
    IdColoniaFacturacionOnline: number | null;
}

export interface FacturacionOnline {
    Folios: string[];
    Receptor: ReceptorFactura;

    IdColoniaFacturacionOnline: number | null;

    DireccionFacturacionOnline: Direccion;

    CorreoFacturacion: string;

}

export interface FiltroFacturas {
    Ids?: number[] | null;
    FechaInicio?: Date | string | null;
    FechaFinal?: Date | string | null;
    FechaPagoInicio?: Date | string | null;
    FechaPagoFinal?: Date | string | null;
    SerieFolio?: string;
    IdSucursal?: number | null;
    IdCliente?: number | null;
    Origen?: OrigenFactura | null;
    EsNotaCredito?: boolean | null;
    EsNotaCargo?: boolean | null;
    EsTimbrada?: boolean | null;
    EsCancelada?: boolean | null;
    EsREP?: boolean | null;
    Limite?: number | null;
    IdSucursalCobranza?: number | null;
    DeCredito?: boolean | null;
    TieneCliente?: boolean | null;
    Pagada?: boolean | null;
    IdViajeCobranza?: number | null;

    FechaCancelacionInicio?: Date | string | null;
    FechaCancelacionFinal?: Date | string | null;

    EsFacturaLogistica: boolean;
}


/**Datos necesarios para la inicialización de una factura nueva  */
export interface DatosInicioFactura {
    ClaveSatMonedaManual: string;
    ClaveSatRegimenFiscalManual: string;
    ClaveSatUsoCFDINotaDeCredito: string;
}


// WEBPACK FOOTER //
// ./app/models/factura.ts